module.exports = __webpack_public_path__ + "static/media/volumeTwo03.24fa200b.jpg";